import { useState } from "react"
import { ImagePlaceholderBox, MealImage } from "./styled"

const SmallImagePlaceholder = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
    >
      <path
        d="M9.97501 4.71895C12.2692 4.43094 14.2554 5.76922 14.847 8.06431L14.846 8.06466C15.0539 8.87143 15.0554 9.68519 14.9616 10.507C14.8157 11.7892 14.4477 13.007 13.8911 14.1686C13.3754 15.2449 12.7233 16.2257 11.7772 16.9874C11.197 17.4544 10.5488 17.7816 9.80081 17.8714C9.22203 17.941 8.65311 17.8732 8.11134 17.6474L8.11028 17.647C8.04013 17.618 7.95977 17.618 7.88962 17.647L7.88856 17.6474C7.34714 17.8732 6.77787 17.941 6.19909 17.8714C5.45111 17.7816 4.80288 17.4544 4.22269 16.9874C3.27696 16.2261 2.62486 15.2452 2.10882 14.1686C1.55224 13.007 1.18424 11.7892 1.03831 10.507C0.944901 9.68519 0.945959 8.87108 1.15393 8.06431C1.72825 5.83639 3.61635 4.5101 5.82497 4.69782C5.68808 4.64572 5.55286 4.58608 5.41929 4.5189C5.13668 4.37735 4.88381 4.19459 4.6607 3.97062C4.16984 3.47788 3.8539 2.89168 3.71289 2.212C3.57129 1.53292 3.53767 0.842495 3.61205 0.14072C4.31115 0.0660629 4.99924 0.0995091 5.67633 0.241059C6.35282 0.383205 6.93649 0.700646 7.42735 1.19338C7.76946 1.5368 8.01846 1.92502 8.17435 2.35803C8.33083 2.79104 8.43138 3.24645 8.476 3.72425C8.66937 3.26138 8.90379 2.82449 9.17927 2.41357C9.45415 2.00326 9.76264 1.62639 10.1048 1.28297C10.2684 1.11872 10.4766 1.0366 10.7295 1.0366C10.9824 1.0366 11.1906 1.11872 11.3542 1.28297C11.5178 1.44722 11.5996 1.65625 11.5996 1.91009C11.5996 2.16392 11.5178 2.37296 11.3542 2.53721C11.027 2.8657 10.7369 3.22763 10.4841 3.62302C10.2634 3.96855 10.0937 4.33386 9.97501 4.71895Z"
        fill="rgba(0, 38, 58, 0.32)"
      />
    </svg>
  )
}
interface IProps {
  src?: string
  placeholderBg?: string
}

const SmallFoodImage = ({ src, placeholderBg = '#E6E6E6' }: IProps) => {
  const [hasError, setHasError] = useState(false)

  const handleError = () => {
    setHasError(true)
  }

  if (hasError || !src) {
    return (
      <ImagePlaceholderBox $placeholderBg={placeholderBg}>
        <SmallImagePlaceholder />
      </ImagePlaceholderBox>
    )
  }

  return <MealImage src={src} alt={"meal-photo"} onError={handleError} />
}

export default SmallFoodImage
